import React from "react";
import { ReactSVG } from "react-svg";
import style from "./style.module.css";

const SVG = ({ src, className = style.svgFile, onClick = () => { }, title }) => {
    return <ReactSVG className={className} src={src} onClick={() => { onClick(); }} title={title} />
};

export default SVG;